<template>
  <div class="animated fadeIn">
    <div>
      <sample-type-selector :sampleTypes="sample_types" />
      <template v-if="selected_sample_type_id">
        <process-type-selector :process_types="process_types" />
        <template v-if="process_types.length">
          <template v-if="selected_process_type">
            <process-selector :context_process_list="context_process_list" />
            <template v-if="selected_processes.length">
              <instrument-list
                v-for="(process, index) in selected_processes"
                :key="index"
                :process="process"
              />
            </template>
            <div v-else>
              <hr class="mt-0" />
              <b-alert show class="mb-4"
                >Select a process to see available instruments.</b-alert
              >
            </div>
          </template>
          <div v-else>
            <hr class="mt-0" />
            <b-alert show class="mb-4"
              >Select a process types to see available processes.</b-alert
            >
          </div>
        </template>
      </template>
      <div v-else>
        <hr class="mt-0" />
        <b-alert show class="mb-4"
          >Select a sample types to see available process categories.</b-alert
        >
      </div>
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import InstrumentList from "./components/InstrumentList";
import ProcessSelector from "./components/ProcessSelector";
import ProcessTypeSelector from "./components/ProcessTypeSelector";
import SampleTypeCollection from "@/collections/lab/SampleTypeCollection";
import SampleTypeSelector from "./components/SampleTypeSelector";

import { mapGetters } from "vuex";

export default {
  name: "ScheduleForm",
  components: {
    InstrumentList,
    ProcessSelector,
    ProcessTypeSelector,
    SampleTypeSelector,
  },
  props: {
    sample_types: {
      type: SampleTypeCollection,
      default: () => new SampleTypeCollection(),
    },
    context_prep_processes: {
      type: Object,
      default: () => null,
    },
    context_test_processes: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    ...mapGetters({ schedule_form: "scheduleForm" }),
    selected_sample_type_id() {
      return this.schedule_form.sample_type_id;
    },
    selected_processes() {
      return this.schedule_form.processes;
    },
    selected_process_type() {
      return this.schedule_form.process_type;
    },
    process_types() {
      let types = [];

      if (
        this.context_prep_processes &&
        this.context_prep_processes.models.length
      ) {
        types = [...types, "Prep"];
      }

      if (
        this.context_test_processes &&
        this.context_test_processes.models.length
      ) {
        types = [...types, "Testing"];
      }
      return types;
    },
    context_process_list() {
      return this.selected_process_type
        ? this.selected_process_type === "Prep"
          ? this.context_prep_processes
          : this.context_test_processes
        : null;
    },
  },
};
</script>
